export const ids = {
	chatAssistantInputId: 'chat-assistant-input-id',
}
